import React, { useEffect, useState } from "react";
import { AutoSearch } from "~/core";
import { messages } from "./../i18n-messages";
import classnames from "classnames";
import { CustomerAPI } from "@ai360/core";
import { useIntl } from "react-intl";

interface IProps {
    classNames: string;
    clearOnSelection: boolean;
    containerClassName: string;
    itemList: CustomerAPI.ISalespersonCustomer[];
    onSelection: (selected: CustomerAPI.ISalespersonCustomer) => void;
    placeholderText: string;
    selectedValue: string;
    showTopLabel?: boolean;
}

export const SALESPERSON_GUID = "salespersonGuid";
export const SALESPERSON_PERSON_NAME = "personName";
export const SALESPERSON_ID = "salespersonId";
const SALESPERSON_CITY = "city";
const SALESPERSON_STATE_ABR = "stateAbbreviation";

export function SalespersonCustomerSearch(props: IProps) {
    const {
        classNames,
        clearOnSelection = false,
        containerClassName,
        itemList = [],
        onSelection,
        placeholderText,
        selectedValue = "",
        showTopLabel = true,
    } = props;
    const { formatMessage } = useIntl();

    const [resetOptions, setResetOptions] = useState(false);

    useEffect(() => {
        setResetOptions(true);
    }, [itemList]);

    return (
        <div className={classnames("form-section-child-stretch", containerClassName)}>
            <AutoSearch
                classNames={[classnames(classNames)]}
                clearOnSelection={clearOnSelection}
                disabled={false}
                initialFilterStr={""}
                itemList={itemList}
                keyProp={SALESPERSON_GUID}
                nameProp={SALESPERSON_PERSON_NAME}
                onResetOptions={() => setResetOptions(false)}
                onSelection={(item: CustomerAPI.ISalespersonCustomer) => onSelection(item)}
                placeholderText={placeholderText || formatMessage(messages.addSalesperson)}
                secondaryPropList={[SALESPERSON_ID, SALESPERSON_CITY, SALESPERSON_STATE_ABR]}
                resetOptions={resetOptions}
                selectedValue={selectedValue}
                showTopLabel={showTopLabel}
            />
        </div>
    );
}
